import React from "react";

const TermsOfUse = () => {
return (
    <div className="legals-box">
        <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
        <p className="mb-6">Effective Date: 15/07/2025</p>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">1. Eligibility</h2>
            <p>
                To use the Service, you must be at least 18 years old and capable of
                entering into legally binding contracts. By registering for the
                Service, you represent and warrant that you meet these eligibility
                requirements.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">2. Accounts and Registration</h2>
            <p>
                You may access the Service by registering for an account using your
                email or via third-party authentication providers such as Google. You
                are responsible for maintaining the confidentiality of your account
                credentials and for all activities that occur under your account.
            </p>
            <ul className="list-disc list-inside mt-2">
                <li>Provide accurate, current, and complete information;</li>
                <li>Maintain the security of your password;</li>
                <li>
                    Notify us immediately of any unauthorized use or security breach of
                    your account.
                </li>
            </ul>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">3. Use of the Service</h2>
            <p>
                Our platform allows users to:
            </p>
            <ul className="list-disc list-inside mt-2">
                <li>Upload email lists for validation and scrubbing;</li>
                <li>Purchase credits via Stripe to process their data;</li>
                <li>Download cleaned email lists after processing.</li>
            </ul>
            <p className="mt-2">
                You retain ownership of any data you upload. We claim no ownership
                rights over your content. However, by using our Service, you grant us
                a limited, non-exclusive license to process and store your content
                solely for the purpose of providing the Service.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">4. Payments and Credits</h2>
            <p>
                The Service operates on a pay-as-you-go model using credits. You may
                purchase credits through our secure payment processor, Stripe. Credits
                are non-refundable and non-transferable unless required by applicable
                law.
            </p>
            <p className="mt-2">
                You are responsible for any taxes or fees associated with your
                purchases.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">5. Data Processing and Privacy</h2>
            <p>
                We respect your privacy and comply with the General Data Protection
                Regulation (GDPR). All user data and processed email lists are stored
                on servers located in the European Union.
            </p>
            <p className="mt-2">
                We use cookies and Google Tag Manager for analytics and functional
                tracking. By using our Service, you consent to the use of cookies and
                similar technologies as described in our <a href="/cookie-policy" className="text-blue-600 underline">Cookie Policy</a>.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">6. Third-Party Services</h2>
            <p>
                The Service integrates with third-party platforms such as Google (for
                login) and Stripe (for payments). Your use of these third-party
                services is subject to their respective terms and privacy policies.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">7. Termination</h2>
            <p>
                You may terminate your account at any time. We reserve the right to
                suspend or terminate your access to the Service at our sole discretion
                if you violate these Terms or engage in harmful activity.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">8. Disclaimer of Warranties</h2>
            <p>
                The Service is provided "as is" and "as available". We make no
                warranties, express or implied, including but not limited to
                merchantability, fitness for a particular purpose, and
                non-infringement.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">9. Limitation of Liability</h2>
            <p>
                To the maximum extent permitted by law, Scrubmail s.r.o shall not
                be liable for any indirect, incidental, or consequential damages
                arising from your use of the Service.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">10. Indemnification</h2>
            <p>
                You agree to indemnify, defend, and hold harmless ScrubMail s.r.o,
                its officers, directors, employees, and affiliates from any claims,
                damages, or expenses arising out of your use of the Service or your
                violation of these Terms.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">11. Changes to Terms</h2>
            <p>
                We may update these Terms from time to time. Changes will be effective
                upon posting to our website. Continued use of the Service after such
                updates constitutes your acceptance of the revised Terms.
            </p>
        </section>

        <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">12. Governing Law</h2>
            <p>
                These Terms are governed by the laws of the European Union and Slovakia, without regard to its conflict of laws
                principles.
            </p>
        </section>

        <section>
            <h2 className="text-2xl font-semibold mb-2">13. Contact Us</h2>
            <p>
                If you have any questions about these Terms, please contact us at:
            </p>
            <ul className="mt-2">
                <li>📧 Email: support@scrubmail.com</li>
                <li>🏢 Address: Ja Som Bratislava 123, 85101 Bratislava, Slovakia</li>
            </ul>
        </section>
    </div>
);
};
export default TermsOfUse;